@if (showStatusUpdateModal) {
<app-dialog-title>
  {{ 'bulk-update-tax-return-alias-status' | transloco: {taxReturnAlias} }}
</app-dialog-title>
<div class="status-container">
  <mat-dialog-content class="content">
    @if (bulkActionState !== 'COMPLETED') {
    <div>
      @if (selectedTaxReturnIds.length<=0) {
      <p>
        {{ 'please-select-tax-return-alias-s-to-update-status' | transloco: {taxReturnAlias} }}
      </p>
      } @if (selectedTaxReturnIds.length>0) {
      <div>
        <p>
          Are you sure that you want to update status for the
          {{ selectedTaxReturnIds.length }} selected {{ taxReturnAlias }}s?
        </p>
        @if (errorMessage) {
        <p class="error-message">{{ errorMessage }}</p>
        }
        <app-search-dropdown
          class="app-search-dropdown"
          label="select"
          [formGroup]="statusUpdateForm"
          [formCtrl]="getFormControl()"
          [listOptions]="statusOptions"
          [placeholder]="placeholder"
          (selectedItem)="onStatusSelection($event)"
        ></app-search-dropdown>
      </div>
      }
    </div>
    } @if (bulkActionState === 'COMPLETED') {
    <div>
      @for (item of statusUpdateResponse; track item) {
      <div>
        @if (item.success) {
        <p>
          <i class="green check icon"></i>
          <strong
            >{{ selectedTaxReturns[item.id].firstName }}
            {{ selectedTaxReturns[item.id].lastName }} #{{ item.id }}</strong
          >: Success.
        </p>
        } @if (!item.success) {
        <p>
          <i class="red x icon"></i>
          <strong
            >{{ selectedTaxReturns[item.id].firstName }}
            {{ selectedTaxReturns[item.id].lastName }} #{{ item.id }}</strong
          >:
          {{ item.errorMessage || "Failed to update status." }}
        </p>
        }
      </div>
      }
    </div>
    }
  </mat-dialog-content>
</div>
@if (bulkActionState !== 'COMPLETED') {
<mat-dialog-actions align="end">
  <a class="go-back cancel" (click)="onClose()">{{ "cancel" | transloco }}</a>
  <button
    class="ui primary button"
    (click)="updateStatus()"
    [disabled]="!selectedStatusOption || bulkActionState === 'LOADING'"
    [ngClass]="{ loading: bulkActionState === 'LOADING' }"
  >
    {{ "update-status" | transloco }}
  </button>
</mat-dialog-actions>
} @if (bulkActionState === 'COMPLETED') {
<mat-dialog-actions align="end">
  <button class="ui primary button" (click)="onClose(true)">
    {{ "ok" | transloco }}
  </button>
</mat-dialog-actions>
} }
